import { FileId, SuretyAccountId, SuretyQuoteId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { bondRequestsQueryKey } from "../bond-request.keys";
import { invalidateBondRequestIfClosed, redirectToIssuedBond } from "../utils";

export const useUploadAgentIssuedBondForm = (accountId: SuretyAccountId, id: SuretyQuoteId) => {
	const queryClient = useQueryClient();
	const { post } = useRequest();

	const mutation = useMutation({
		meta: { redirectOnError: redirectToIssuedBond },
		mutationFn: async (fileId: FileId): Promise<void> => {
			await post(`/v2/surety/accounts/${accountId}/quotes/${id}/bond-form/agent-issue`, {
				fileId,
			});
		},
		onSuccess: () => {
			queryClient.refetchQueries({ queryKey: bondRequestsQueryKey(id) });
		},
		onSettled: invalidateBondRequestIfClosed(queryClient, id),
	});

	return {
		uploadAgentIssuedBondForm: mutation.mutate,
		uploadAgentIssuedBondFormIsLoading: mutation.isPending,
	};
};
